import Model, { attr } from '@ember-data/model';
import { htmlSafe } from '@ember/template';

export default class AnnouncementModel extends Model {
  @attr('string') declare message: string;
  @attr('boolean') declare read: boolean;

  get messageHtmlSafe() {
    return htmlSafe(this.message);
  }
}

declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    announcement: AnnouncementModel;
  }
}
